import { render, staticRenderFns } from "./sellers-participation.modal.vue?vue&type=template&id=bfafd994&scoped=true&"
import script from "./sellers-participation.modal.vue?vue&type=script&lang=js&"
export * from "./sellers-participation.modal.vue?vue&type=script&lang=js&"
import style0 from "./sellers-participation.modal.vue?vue&type=style&index=0&id=bfafd994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafd994",
  null
  
)

export default component.exports